import { makeStyles } from "@material-ui/styles";
import { colorConstant } from "../../style/Color.constant";

export default makeStyles((theme) => ({
  react_autosuggest__input: {
    border: "none",
    borderBottom: "1px solid #80d3f9 !important",
    color: "#212121",
    padding: "4px",
    fontSize: "12px",
    maxWidth: "100%",
    width:"100%"
  },
  react_autosuggest__input_disabled: {
    background: "rgba(0, 0, 0, 0.09)",
    padding: "4px",
    fontSize: "12px",
    border: "none",
  },
  react_autosuggest__suggestions_container: {
    position: "absolute",
    background: "#e1f5fe",
    opacity: 1,
    zIndex: 999999999,
    width: "11.6%",
    fontSize: "12px",
    minWidth: "105px",
  },
  autoDropdown: {
    fontSize: "12px !important",
    marginTop: ".4em",
  },
  react_autosuggest__suggestions_container2: {
    position: "absolute",
    background: "#e1f5fe",
    opacity: 1,
    zIndex: 999999999,
    width: "100%",
    fontSize: "12px",
    minWidth: "105px",
  },
  react_autosuggest__suggestions_list: {
    listStyleType: "none",
  },
  react_autosuggest__suggestion: {
    paddingTop: "5px",
    paddingBottom: "5px",
    borderBottom: "1px solid #d0d3d7",
  },
  formSection: {
    width: "50%",
  },
  forgetLink: {
    float: "right",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.36,
    letterSpacing: "normal",
    textAlign: "right",
    color: colorConstant.linkColor,
    marginTop: ".3em",
    cursor: "pointer",
  },
  passwordFormGroup: {
    marginBottom: 0,
  },
  forgotFormGroup: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 0,
    marginBottom: 0,
  },
  emailFormGroup: {
    marginBottom: 0,
  },
  errorTextStyle: {
    fontSize: " 0.75rem",
    marginTop: "3px",
    textAlign: "left",
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    color: colorConstant.errorRed,
  },
  loginButton: {
    textTransform: "capitalize",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    backgroundColor: colorConstant.blueTheme,
    borderColor: colorConstant.blueTheme,
  },
  loginFormGroup: {
    marginTop: "2em",
  },
  loginTitle: {
    textAlign: "center",
    fontSize: "22px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.23,
    letterSpacing: "normal",
    // marginBottom: '2em'
  },
  backToLoginFormGroup: {
    display: "flex",
    justifyContent: "flex-end",
  },
  myProfileForm: {
    fontSize: 14,
    // marginLeft: '3em'
  },
  formTitle: {
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.21,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#212121",
    paddingBottom: "2em",
  },
  exapansionPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0,
  },
  padding0: {
    padding: 0,
  },
  width100: {
    width: "100%",
  },
  formFields: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#212121",
  },
  reminders: {
    background: "#e1f5fe",
    padding: ".75em",
  },
  remTitle: {
    fontWeight: "bold",
  },
  remDesc: {
    marginTop: ".5em",
    textTransform: "uppercase",
    paddingRight: "12px",
    wordBreak: "break-word",
    // height: "60%",
    // overflowY: "auto",
    // height: "30px",
    // overflow-y: "auto";
  },
  buttonNone: {
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    textTransform: "capitalize",
    fontSize: 12,
  },
  buttonThirtyOne: {
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    fontSize: 11,
  },
  tabTitle: {
    fontWeight: "bold",
  },
  tabSubTitle: {
    fontWeight: "bold",
    paddingTop: 15,
    paddingBottom: 20,
  },
  firstWarning: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    color: "#d32f2f",
    fontSize: 12,
  },
  listStyle: {
    listStyleType: "none",
    marginBottom: 0,
    lineHeight: "1.7em",
  },
  dNone: {
    display: "none",
  },
  commonButton: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    textTransform: "capitalize",
    fontSize: 12,
    color: "#000",
    border: "1px solid #757575",
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  commonButtonSuccess: {
    backgroundColor: "#01345d",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    textTransform: "capitalize",
    fontSize: 12,
    color: "#fff",
    border: "1px solid #01345d",
    "&:hover": {
      color: "#fff",
    },
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  hasLapse110: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    textTransform: "capitalize",
    fontSize: 12,
    color: "#000",
    border: "1px solid #757575",
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  hasLapse110Success: {
    backgroundColor: "#01345d",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    textTransform: "capitalize",
    fontSize: 12,
    color: "#fff",
    border: "1px solid #01345d",
    borderRight: "1px solid #fff",
    borderLeft: "1px solid #fff",
    "&:hover": {
      color: "#fff",
    },
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  noneButton: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    textTransform: "capitalize",
    fontSize: 12,
    color: "#000",
    border: "1px solid #757575",
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  noneButtonSuccess: {
    backgroundColor: "#01345d",
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    textTransform: "capitalize",
    fontSize: 12,
    color: "#fff",
    border: "1px solid #01345d",
    "&:hover": {
      color: "#fff",
    },
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  datePicker: {
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
    // width: 200,
  },
  tabhighlightedTitle: {
    color: "#03a9f4",
    fontSize: 12,
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  summaryForm: {
    width: "70%",
  },
  warningForm: {
    width: "30%",
  },
  warningCheckBox: {
    padding: "1em",
  },
  createUserButton: {
    textTransform: "capitalize",
    height: "35px",
    width: "60px",
    borderRadius: "6px",
    background: "#01579b",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.21,
    letterSpacing: "normal",
    textAlign: "center",
  },
  cancelButton: {
    textTransform: "capitalize",
    height: "35px",
    width: "60px",
    borderRadius: "6px",
    background: "#fff",
    color: "#01579b",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.21,
    letterSpacing: "normal",
    textAlign: "center",
    marginRight: "10px",
    border: "solid 1px #01579b",
  },
  eventList: {
    height: "100vh",
    overflow: "auto",
    paddingLeft: 10,
  },
  nirrStyle: {
    marginTop: "1em",
  },
  eventRow: {
    marginBottom: ".5em",
    marginLeft: 0,
    marginRight: 0,
  },
  remindeTitle: {
    cursor: "pointer",
  },
  formPadding: {
    padding: "1em",
  },
  saveBtn: {
    background: "#014e8c",
    color: "#fff",
    textTransform: "capitalize",
  },
  merge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  eventList1: {
    height: "400px",
    overflow: "auto",
    paddingLeft: 10,
  },
  editableInput: {
    background: "#fff",
    paddingLeft: "5px",
    paddingRight: "2px",
    fontSize: "12px !important",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.33,
    letterSpacing: "normal",
    textAlign: "left",
    borderBottom: "1px solid #81d4fa !important",
    "&:before": {
      borderBottom: "1px solid #007bff !important",
    },
  },
  formProperties: {
    fontSize: 12,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
  },
  disabledInput: {
    background: "rgba(0, 0, 0, 0.09)",
    paddingLeft: "5px",
    paddingRight: "2px",
    fontSize: "12px !important",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.33,
    letterSpacing: "normal",
    textAlign: "left",
    "&:before": {
      borderBottom: "1px solid #757575",
    },
  },
  autoDropdown: {
    fontSize: "12px !important",
    marginTop: ".4em",
    borderBottom: "1px solid #81d4fa"
  },
  autoDropdownroot: {
    fontSize: "12px !important",
    marginTop: ".4em",
  },
  reverseRow:{
    background:'#fff',
    padding:'1em'
  }
}));
